export enum InsightTypes {
  TotalWithAccounts = 'TOTAL_WITH_ACCOUNTS',
  UnderServed = 'UNDER_SERVED',
  UnderPerforming = 'UNDER_PERFORMING',
  OverSpent = 'OVER_SPENT',
  ValueLift = 'VALUE_WITH_ADS',
  VelocityLift = 'VELOCITY_WITH_ADS',
}
